export const getPropertyName = (id) => {
    return `_feature_flag_${id}`;
};
export const parsePropertyValue = (value) => {
    return value === "ON";
};
